import React, { useState, useEffect } from "react";
import { Drawer, Radio } from "antd";
import { LabelPadrao } from "../../components/Base";
import SelectLojas from "../../components/SelectLojas";
import SelectFiltros from "../../components/SelectFiltros";
import SelectEstadosCidades from "../../components/SelectEstadosCidades/SelectEstadosCidades";

function DrawerFiltros({ filtros, setFiltros, modelo }) {
  useEffect(() => {
    setFiltros(state => { return { ...state, tipo: !modelo ? "lojas" : filtros.tipo } });
  }, []);

  return (
    <>
      {/* <pre>{JSON.stringify(filtros, null, 2)}</pre> */}
      {!modelo &&
        <div style={{ display: "flex" }}>
          <Radio.Group value={filtros.tipo} onChange={v => setFiltros({ ...filtros, tipo: v.target.value })}>
            <Radio value="lojas">
              <b>Lojas</b>
            </Radio>
            <Radio value="caracte">
              <b>Características</b>
            </Radio>
          </Radio.Group>
        </div>
      }

      {(filtros.tipo === "lojas" && !modelo) && (
        <div style={{ marginTop: 10 }}>
          <SelectLojas value={filtros.lojas} setValue={v => setFiltros(state => { return { ...state, lojas: v } })} />
        </div>
      )}
      {(filtros.tipo === "caracte" || (modelo === "caracteristica" && modelo !== "loja")) && (
        <div >
          <LabelPadrao>Segmento</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=segmento" value={filtros.segmento} onChange={v => setFiltros({ ...filtros, segmento: v })} mode="multiple" maxTagCount={1} />
          <LabelPadrao>Faixa de Faturamento</LabelPadrao>
          <SelectFiltros
            modelo="caracteristica?filtro=fxFaturamento"
            value={filtros.fxFaturamento}
            onChange={v => setFiltros({ ...filtros, fxFaturamento: v })}
            mode="multiple"
            maxTagCount={1}
          />
          <LabelPadrao>Porte do PDV</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=portepdv" value={filtros.porte} onChange={v => setFiltros({ ...filtros, porte: v })} mode="multiple" maxTagCount={1} />
          <LabelPadrao>Modelo de Negocio</LabelPadrao>
          <SelectFiltros
            modelo="caracteristica?filtro=modeloneg"
            value={filtros.modeloNegocio}
            onChange={v => setFiltros({ ...filtros, modeloNegocio: v })}
            mode="multiple"
            maxTagCount={1}
          />
          <LabelPadrao>Tipo de Empresa</LabelPadrao>
          <SelectFiltros
            modelo="caracteristica?filtro=tipoemp"
            value={filtros.tipoEmpresa}
            onChange={v => setFiltros({ ...filtros, tipoEmpresa: v })}
            mode="multiple"
            maxTagCount={1}
          />
          <LabelPadrao>Perfil</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=perfil" value={filtros.perfil} onChange={v => setFiltros({ ...filtros, perfil: v })} mode="multiple" maxTagCount={1} />
          <SelectEstadosCidades
            cidade={filtros.cidade}
            estado={filtros.estado}
            setCidade={v => setFiltros({ ...filtros, cidade: v })}
            setEstado={v => setFiltros({ ...filtros, estado: v })}
            mode="multiple"
            maxTagCount={1}
          />
          <LabelPadrao>Região Comercial</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=rgComer" value={filtros.regiaoComercial} onChange={v => setFiltros({ ...filtros, regiaoComercial: v })} mode="multiple" />
          <LabelPadrao>Região Geografica</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=rgGeo" value={filtros.regiaoGeografica} onChange={v => setFiltros({ ...filtros, regiaoGeografica: v })} mode="multiple" />

          <LabelPadrao>Rede</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=rede" value={filtros.rede} onChange={v => setFiltros({ ...filtros, rede: v })} mode="multiple" />
          <LabelPadrao>Federação</LabelPadrao>
          <SelectFiltros modelo="caracteristica?filtro=federacao" value={filtros.federacao} onChange={v => setFiltros({ ...filtros, federacao: v })} mode="multiple" />
        </div>
      )}
    </>
  );
}

export default DrawerFiltros;
